import type { BarSeriesOption } from "echarts/charts";
import { BarChart } from "echarts/charts";
import type {
  GridComponentOption,
  LegendComponentOption,
  TitleComponentOption,
  TooltipComponentOption,
} from "echarts/components";
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from "echarts/components";
import type { ComposeOption } from "echarts/core";
import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import ReactEcharts from "echarts-for-react";

// Reduce bundle size: see https://echarts.apache.org/handbook/en/basics/import/#shrinking-bundle-size
echarts.use([
  BarChart,
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
]);

// Create an Option Type: see https://echarts.apache.org/handbook/en/basics/import/#creating-an-option-type-in-typescript
export type ECOption = ComposeOption<
  | BarSeriesOption
  | TitleComponentOption
  | TooltipComponentOption
  | GridComponentOption
  | LegendComponentOption
>;

type ReactBarChartProps = {
  option: ECOption;
};

function ReactBarChart({ option }: ReactBarChartProps) {
  return (
    <ReactEcharts
      style={{ width: "100%", height: "100%" }}
      echarts={echarts}
      option={option}
    />
  );
}

ReactBarChart.displayName = "ReactBarChart";

export default ReactBarChart;
